import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg, BACKEND } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/studio" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
      nav("/studio");
    } catch (err) { setError(errMsg(err)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-[1.2fr_1fr] bg-[#FDFBF7]">
      <div className="relative hidden lg:block overflow-hidden">
        <img src={`${BACKEND}/api/scene/base.jpg`} alt="" className="absolute inset-0 h-full w-full object-cover" />
      </div>
      <form onSubmit={submit} data-testid="login-form" className="flex flex-col justify-center px-8 sm:px-16 py-16 max-w-lg w-full mx-auto">
        <p className="eyebrow mb-4">Acceso privado</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl text-[#1C1715] font-light">Estudio LUMINA</h1>
        <p className="mt-4 text-sm text-[#5C534C]">Gestiona las fotografías y el vídeo de la portada.</p>
        <div className="mt-12 space-y-6">
          <div className="space-y-2">
            <Label htmlFor="email">Correo</Label>
            <Input id="email" data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-12 bg-white" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Contraseña</Label>
            <Input id="password" data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="h-12 bg-white" />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-700">{error}</p>}
          <Button data-testid="login-submit-button" disabled={busy} className="h-12 w-full rounded-full uppercase tracking-[0.2em] text-xs">
            {busy ? "Entrando…" : "Entrar"}
          </Button>
        </div>
      </form>
    </div>
  );
}
